export enum PlateformeFormFieldNames {
  Name = 'name',
  Code = 'code',
  /** Mode de connexion (STANDARD | SSO_PARTENAIRE) — édition corporate uniquement. */
  ConnectionMode = 'connectionMode',
  PrimaryColor = 'primaryColor',
  SecondaryColor = 'secondaryColor',
  BackgroundColor = 'backgroundColor',
  SurfaceColor = 'surfaceColor',
  AccentColor = 'accentColor',
  ErrorColor = 'errorColor',
  SuccessColor = 'successColor',
  WarningColor = 'warningColor',
  InfoColor = 'infoColor',
  FontFamily = 'fontFamily',
  LogoFile = 'logoFile',
  MinimalLogoFile = 'minimalLogoFile',
  // Champs de la personne morale « corporate » principale créée avec la plateforme.
  // Le nom de la plateforme (Name) sert de désignation de la PM.
  Phone = 'phone',
  RegistrationNumber = 'registrationNumber',
  Capital = 'capital',
  RcsCity = 'rcsCity',
  RcsNumber = 'rcsNumber',
  OriasNumber = 'oriasNumber',
  Rcp = 'rcp',
  /** Email du compte corporate (créé automatiquement au format <slug>.corporate). */
  Email = 'email',
  /** Rôles ABP métier en plus d'Plateforme + Assureur (liste blanche serveur). */
  AdditionalRoles = 'additionalRoles',
  SousNature = 'sousNature',
  /** Comptes bancaires (destination des commissions dans les tunnels). */
  BankAccounts = 'bankAccounts',
}
